function convertNewLinesToBr(text: string) {
  return text?.replace(/\n/g, "<br>");
}


export default convertNewLinesToBr;